export const languages = {
  nb_NO: {
    'accordionItem.step': 'Steg',
    'datepicker.calendar': 'Kalender',
    'datepicker.goToToday': 'I dag',
    'datepicker.invalidInputErrorMessage': 'Datoen er ikke gyldig. (format: {{DEFAULT_DATE_FORMAT}})',
    'datepicker.isOutOfBoundsErrorMessage': 'Datoen er ikke innenfor gyldig periode.',
    'datepicker.isRequiredErrorMessage': 'Dato må fylles ut',
    'datepicker.nextMonthAriaLabel': 'Neste måned',
    'datepicker.nextYearAriaLabel': 'Neste år',
    'datepicker.prevMonthAriaLabel': 'Forrige måned',
    'datepicker.prevYearAriaLabel': 'Forrige år',
    'dialog.waitAlert.alt': 'Illustrasjon av travel person med seks armer, opptatt med kontorarbeid.',
    'dialog.waitAlert.button_text': 'Ja',
    'dialog.waitAlert.paragraph': 'Vi ser at du ikke har gjort noe på nettsiden på ei stund. Er du fortsatt her?',
    'dialog.waitAlert.title': 'Hei!',
    'common.close': 'Lukk',
    'common.edit': 'Rediger',
    'common.help': 'Hjelp',
    'common.helpText': 'Hjelptekst',
    'common.warning': 'Varsel',
    'fileuploader.accepted_file_formats': 'Aksepterte filformater:',
    'fileuploader.add.label': 'Legg til fil(er)',
    'fileuploader.delete.ariaLabel': 'Fjern fil',
    'fileuploader.error.delete.403': 'Du har ikke rettigheter til å slette filer.',
    'fileuploader.error.delete.general': 'Kunne ikke slette fil',
    'fileuploader.error.file_format': 'Dette filformatet er ikke godkjent',
    'fileuploader.error.file_size': 'Vi kan ikke motta denne filen fordi den er for stor. Filer kan ikke overstige {{filstoerrelsegrense}} Mb. Du kan forsøke å dele opp i flere mindre filer, eller bruke et format som tar mindre plass.',
    'fileuploader.error.upload.403': 'Du har ikke rettigheter til å laste opp filer.',
    'fileuploader.error.upload.general': 'Kunne ikke laste opp fil',
    'fileuploader.uploaded.sr_heading': 'Lastet opp:',
    'pagination.next': 'Neste',
    'pagination.page': 'Side',
    'pagination.pageNavigation': 'Sidevelger',
    'pagination.previous': 'Forrige',
    'scrollToTopButton.backToTop': 'Til toppen',
    'searchfield.sok': 'Søk',
    'searchfield.focus': 'Bruk piltaster ned/opp for å velge forslag når de vises',
    'searchfield.results': '{{ant}} forslag vises.',
    'table.sortable': 'sorterbar',
    'table.sorted_ascending': 'sortert stigende',
    'table.sorted_descending': 'sortert synkende',
    'tablerow.editable.title': 'Rediger rad',
    'tablerow.expandable.title': 'Mer informasjon',
    'topbanner.ske.logo': 'Skatteetaten logo',
    'topbanner.ske.logoLink': 'Forside Skatteetaten',
    'topbanner.ink.logo': 'Statens innkreving logo',
    'topbanner.ink.logoLink': 'Forside Statens innkreving',
    'topbanner.lso.logo': 'Lønnsstøtte logo',
    'topbanner.lso.logoLink': 'Forside Lønnsstøtte'
  },
  nn_NO: {
    'accordionItem.step': 'Steg',
    'datepicker.calendar': 'Kalender',
    'datepicker.goToToday': 'I dag',
    'datepicker.invalidInputErrorMessage': 'Datoen er ikkje gyldig. (format: {{DEFAULT_DATE_FORMAT}})',
    'datepicker.isOutOfBoundsErrorMessage': 'Datoen er ikkje innanfor ein gyldig periode.',
    'datepicker.isRequiredErrorMessage': 'Dato må fyllast ut',
    'datepicker.nextMonthAriaLabel': 'Neste månad',
    'datepicker.nextYearAriaLabel': 'Neste år',
    'datepicker.prevMonthAriaLabel': 'Førre månad',
    'datepicker.prevYearAriaLabel': 'Førre år',
    'dialog.waitAlert.alt': 'Illustrasjon av travel person med seks armar, oppteken med kontorarbeid.',
    'dialog.waitAlert.button_text': 'Ja',
    'dialog.waitAlert.paragraph': 'Vi ser at du ikkje har gjort noko på nettsida på ei stund. Er du framleis her?',
    'dialog.waitAlert.title': 'Hei!',
    'common.close': 'Lukk',
    'common.edit': 'Rediger',
    'common.help': 'Hjelp',
    'common.helpText': 'Hjelptekst',
    'common.warning': 'Varsel',
    'fileuploader.accepted_file_formats': 'Aksepterte filformater:',
    'fileuploader.add.label': 'Legg til fil(er)',
    'fileuploader.delete.ariaLabel': 'Fjern fil',
    'fileuploader.error.delete.403': 'Du har ikkje rettar til å sletta filer.',
    'fileuploader.error.delete.general': 'Kunne ikkje slette fil',
    'fileuploader.error.file_format': 'Dette filformatet er ikkje godkjent',
    'fileuploader.error.file_size': 'Vi kan ikkje få denne fila fordi den er for stor. Filer kan ikkje overstiga {{filstoerrelsegrense}} Mb. Du kan prøva å dela opp i fleire mindre filer, eller bruka eit format som tar mindre plass.',
    'fileuploader.error.upload.403': 'Du har ikkje rettar til å lasta opp filer.',
    'fileuploader.error.upload.general': 'Kunne ikkje lasta opp fil',
    'fileuploader.uploaded.sr_heading': 'Lasta opp:',
    'pagination.next': 'Neste',
    'pagination.page': 'Side',
    'pagination.pageNavigation': 'Sideveljar',
    'pagination.previous': 'Førre',
    'scrollToTopButton.backToTop': 'Til toppen',
    'searchfield.sok': 'Søk',
    'searchfield.focus': 'Bruk piltastane ned/opp for å velje',
    'searchfield.results': '{{ant}} forslag visast.',
    'table.sortable': 'sorterbar',
    'table.sorted_ascending': 'sortert stigande',
    'table.sorted_descending': 'sortert søkkande',
    'tablerow.editable.title': 'Rediger rad',
    'tablerow.expandable.title': 'Meir informasjon',
    'topbanner.ske.logo': 'Skatteetaten logo',
    'topbanner.ske.logoLink': 'Forside Skatteetaten',
    'topbanner.ink.logo': 'Statens innkreving logo',
    'topbanner.ink.logoLink': 'Forside Statens innkreving',
    'topbanner.lso.logo': 'Lønnsstøtte logo',
    'topbanner.lso.logoLink': 'Forside Lønnsstøtte'
  },
  en_GB: {
    'accordionItem.step': 'Step',
    'datepicker.calendar': 'Calendar',
    'datepicker.goToToday': 'Today',
    'datepicker.invalidInputErrorMessage': 'Invalid date format. (format: {{DEFAULT_DATE_FORMAT}})',
    'datepicker.isOutOfBoundsErrorMessage': 'The date is not within a valid period.',
    'datepicker.isRequiredErrorMessage': 'Date is required',
    'datepicker.nextMonthAriaLabel': 'Next month',
    'datepicker.nextYearAriaLabel': 'Next year',
    'datepicker.prevMonthAriaLabel': 'Previous month',
    'datepicker.prevYearAriaLabel': 'Previous year',
    'dialog.waitAlert.alt': 'Illustration of a busy person with six arms, occupied with office work.',
    'dialog.waitAlert.button_text': 'Yes',
    'dialog.waitAlert.paragraph': 'You have been inactive for a while, are you still here?',
    'dialog.waitAlert.title': ' Hi!',
    'common.close': 'Close',
    'common.edit': 'Edit',
    'common.help': 'Help',
    'common.helpText': 'Help text',
    'common.warning': 'Warning',
    'fileuploader.accepted_file_formats': 'Accepted file formats:',
    'fileuploader.add.label': 'Add file(s)',
    'fileuploader.delete.ariaLabel': 'Delete file',
    'fileuploader.error.delete.403': 'You do not have permission to delete files',
    'fileuploader.error.delete.general': "Can't delete file",
    'fileuploader.error.file_format': 'This file format is not accepted',
    'fileuploader.error.file_size': 'We could not receive this file because it is too large. Files cannot exceed {{filstoerrelsegrense}} Mb. You can try splitting the file into smaller files or using a format that takes up less space.',
    'fileuploader.error.upload.403': 'You do not have permission to upload files',
    'fileuploader.error.upload.general': "Can't upload file",
    'fileuploader.uploaded.sr_heading': 'Uploaded:',
    'pagination.next': 'Next',
    'pagination.page': 'Page',
    'pagination.pageNavigation': 'Page navigation',
    'pagination.previous': 'Previous',
    'scrollToTopButton.backToTop': 'Back to top',
    'searchfield.sok': 'Search',
    'searchfield.focus': 'Use up/down to choose options when they are shown',
    'searchfield.results': '{{ant}} items shown.',
    'table.sortable': 'sortable',
    'table.sorted_ascending': 'sorted ascending',
    'table.sorted_descending': 'sorted descending',
    'tablerow.editable.title': 'Edit row',
    'tablerow.expandable.title': 'More information',
    'topbanner.ske.logo': 'The Norwegian Tax Administration logo',
    'topbanner.ske.logoLink': 'Front page The Norwegian Tax Administration',
    'topbanner.ink.logo': 'The Norwegian National Collection Agency logo',
    'topbanner.ink.logoLink': 'Front page The Norwegian National Collection Agency',
    'topbanner.lso.logo': 'Salary subsidy logo',
    'topbanner.lso.logoLink': 'Front page Salary subsidy'
  },
  // TODO FRONT-1072 oppdatere med riktige samiske tekster
  se_NO: {
    'accordionItem.step': 'Lávki',
    'datepicker.calendar': 'Kaleandar',
    'datepicker.goToToday': 'Otne',
    'datepicker.invalidInputErrorMessage': 'Dáhton ii leat gustovaš. (format: {{DEFAULT_DATE_FORMAT}})',
    'datepicker.isOutOfBoundsErrorMessage': 'Dáhton ii leat gustovaš áigodagas.',
    'datepicker.isRequiredErrorMessage': 'Fertet deavdit dáhtona',
    'datepicker.nextMonthAriaLabel': 'Boahtte mánnu',
    'datepicker.nextYearAriaLabel': 'Boahtte jahki',
    'datepicker.prevMonthAriaLabel': 'Ovddit mánnu',
    'datepicker.prevYearAriaLabel': 'Ovddit jahki',
    'dialog.waitAlert.alt': 'Govvideapmi dilihis olbmo geas lea guhtta gieđa ja lea bargamin kánturbargguid.',
    'dialog.waitAlert.button_text': 'Jo',
    'dialog.waitAlert.paragraph': 'Mii oaidnit ahte don it leat geavahan siiddu guhkes áigái. Leat go ain dás?',
    'dialog.waitAlert.title': 'Hei!',
    'common.close': 'Govčča',
    'common.edit': 'Ođasmahttit',
    'common.help': 'Veahkki',
    'common.helpText': 'Veahkketeaksta',
    'common.warning': 'Várrehus',
    'fileuploader.accepted_file_formats': 'Dohkkehuvvon fiilaformáhtat:',
    'fileuploader.add.label': 'Lasit fiilla/fiillaid',
    'fileuploader.delete.ariaLabel': 'Sihko fiilla',
    'fileuploader.error.delete.403': 'Dus eai leat vuoigatvuođat sihkkot fiillaid.',
    'fileuploader.error.delete.general': 'It sáhtán sihkkot fiilla',
    'fileuploader.error.file_format': 'Fiilaformáhta ii leat dohkkehuvvon',
    'fileuploader.error.file_size': 'Mii eat nagot vuostáiváldit fiilla. Fiillat eai sáhte leat stuorát go {{filstoerrelsegrense}} Mb. Sáhtát geahččalit juohkit fiilla eanet osiide, dahje geavahit formáhta mii geavaha unnit saji. ',
    'fileuploader.error.upload.403': 'Dus ii leat vuoigatvuohta lasihit fiillaid.',
    'fileuploader.error.upload.general': 'It sáhtán lasihit fiilla',
    'fileuploader.uploaded.sr_heading': 'Lasihuvvon:',
    'pagination.next': 'Boahtte',
    'pagination.page': 'Siidu',
    'pagination.pageNavigation': 'Siidonavigašuvdna',
    'pagination.previous': 'Ovddit',
    'scrollToTopButton.backToTop': 'Bajás',
    'searchfield.sok': 'Oza',
    'searchfield.focus': 'Geavat vulos/bajás boaluid válljet evttohusaid',
    'searchfield.results': '{{ant}} evttohus/evttohusat.',
    'table.sortable': 'sorterbar',
    'table.sorted_ascending': 'sortert stigande',
    'table.sorted_descending': 'sortert søkkande',
    'tablerow.editable.title': 'Redigere ráiddu',
    'tablerow.expandable.title': 'Eanet dieđut',
    'topbanner.ske.logo': 'Vearroetáhta dovdomearka',
    'topbanner.ske.logoLink': 'Vearroetáhta ovdasiidu',
    'topbanner.ink.logo': 'Stáhta gáibideami dovdomearka',
    'topbanner.ink.logoLink': 'Stáhta gáibideami ovdasiidu ',
    'topbanner.lso.logo': 'Bálkádoarjja dovdomearka',
    'topbanner.lso.logoLink': 'Bálkádoarjja ovdasiidu'
  }
};